<template>
  <div class="dial-back-input">
    <day-range-popup
        :is-visible="isPopupOpen"
        :date-range="dateRange"
        :is-paused="isPaused"
        :dial-back-hours="dialBackHours"
        @date-range-change="handleDateRangeChange"
        @popup-close="handlePopupClose" />
    <div>
      <media-buttons
          :is-active=isLive
          :is-paused=isPaused
          :is-rewind-disabled=isBackDisabled
          :is-fast-forward-disabled=isForwardDisabled
          @pause-clicked="pauseHandler"
          @play-clicked="playHandler"
          @rewind-clicked="rewindHandler"
          @fast-forward-clicked="fastForwardHandler"
      />
      <status-bar :is-active=isLive class="live-status-bar" />
    </div>
    <div>
      <div><button class="timeDisplayButton"
                  @click="openPopup">
          {{ getTimeLabel(dateRange) }}<span v-show="showDownsampling && showDownsamplingLink"> *</span>
              <i class="fa fa-caret-down pull-right"></i>
          </button>
      </div>
      <div class="down-sampling-wrapper">
        <span class="down-sampling-span"  v-show="showDownsampling && showDownsamplingLink">
          * <a class="down-sampling-link" :href="downsamplingLinkHref" target="_blank">Downsampling</a> is in effect
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import BrandingService from '../../services/branding.service';
import DayRangePopup from '../../vueComponents/dateRangePopup/dayRangePopup.vue';
import MediaButtons from '../../vueComponents/mediaButtons/src/mediaButtons.vue';
import moment from 'moment-timezone';
import StatusBar from '../../vueComponents/statusBar/src/statusBar.vue';

export default {
  name: 'DialBackInput',
  props: {
    dateRange: {
      type: Object,
      default: function() {
        return {};
      },
    },
    isBackDisabled: {
      type: Boolean,
      default: true
    },
    isForwardDisabled: {
      type: Boolean,
      default: true
    },
    isLive: {
      type: Boolean,
      default: true
    },
    isPaused: {
      type: Boolean,
      default: false
    },
    mediaButtonHandler: {
      type: Function
    },
    dateRangeHandler: {
      type: Function
    },
    dialBackHours: {
      type: Number,
      default: 720
    },
    showDownsampling: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      isPopupOpen: false,
      downsamplingLinkHref: BrandingService.getSupportUrl('downSampling')
    };
  },
  computed: {
    showDownsamplingLink: function() {
      let rangeInMinutes = 0;
      if (this.dateRange && this.dateRange.endDate && typeof this.dateRange.endDate.diff === 'function') {
        rangeInMinutes = moment.duration(this.dateRange.endDate.diff(this.dateRange.startDate)).asMinutes();
      }
      return rangeInMinutes > 240;
    }
  },
  components: {
    'day-range-popup': DayRangePopup,
    'media-buttons': MediaButtons,
    'status-bar': StatusBar
  },
  methods: {
    getTimeLabel: function(dateRange) {
      if (!dateRange) {
        return 'Change Time Range';
      }
      if (this.isPaused) {
        return dateRange.startDate.format('MMM DD (H:mm)') + ' - ' + dateRange.endDate.format('MMM DD (H:mm)');
      } else {
        let rangeInMinutes = moment.duration(dateRange.endDate.diff(dateRange.startDate)).asMinutes();
        let rangeInHours = moment.duration(dateRange.endDate.diff(dateRange.startDate)).asHours();
        if (rangeInMinutes < 30) {
          return 'IN PROGRESS';
        }
        if (rangeInMinutes < 70) {
          return 'LAST HOUR';
        }
        if (rangeInHours < 5) {
          return 'LAST 4 HOURS';
        }
        if (rangeInHours < 25) {
          return 'LAST 24 HOURS';
        }
        if (rangeInHours < (6 * 24)) {
          return 'LAST 5 DAYS';
        }
        if (rangeInHours < (11 * 24)) {
          return 'LAST 10 DAYS';
        }
        return 'LAST 30 DAYS';
      }
    },
    handleDateRangeChange: function(newDateRange) {
      this.dateRangeHandler(newDateRange);
    },
    handlePopupClose: function() {
      this.isPopupOpen = false;
    },
    openPopup: function(event) {
      if (event.target.className !== 'downsampling-link') {
        this.isPopupOpen = true;
      }
    },
    pauseHandler: function() {
      this.$emit('media-button-pressed', 'pause');
    },
    playHandler: function() {
      this.$emit('media-button-pressed', 'play');
    },
    rewindHandler: function() {
      this.$emit('media-button-pressed', 'back');
    },
    fastForwardHandler: function() {
      this.$emit('media-button-pressed', 'forward');
    }
  }
};
</script>
